import { CurrentUserObject } from "hooks/useVisitorInfo";
import { useFollowUserMutation, useFollowingIdsQuery } from "queries";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { metrics } from "utils/metrics";
import { showAuthModal } from "store/application/application-action";

interface UseFollow {
  currentUser: CurrentUserObject | null;
  username: string;
  context: string | null;
}

export const useFollow = ({
  username,
  context,
  currentUser
}: UseFollow) => {
  const { data: followingIds = [] } = useFollowingIdsQuery();
  const dispatch = useDispatch();
  const followUserMutation = useFollowUserMutation();

  const onFollow = useCallback(async () => {
    if (!currentUser) {
      dispatch(showAuthModal());
      return;
    }

    try {
      await followUserMutation.mutateAsync({ username, context });
      await metrics.sendFollowUserClicked({ userName: username });
      toast.success(`Started following ${username}`);
    } catch (err) {
      toast.error(`Could not follow ${username}`);
    }
  }, [context, followUserMutation, username, currentUser, dispatch]);

  return {
    onFollow,
    followingIds
  };
};
